// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * « Ma feuille de temps » : un panneau qui s'ouvre (éditeur d'un jour,
 * confirmation d'envoi) se déplie en 180 ms. Seuls l'opacité et la position
 * bougent : rien ne force la mise en page à se recalculer. Pas de mouvement
 * pour qui a demandé d'en réduire.
 */
@keyframes feuille-deploiement {
  from { opacity: 0; transform: translateY(-6px); }
  to { opacity: 1; transform: none; }
}

.feuille-deploiement {
  animation: feuille-deploiement 180ms ease-out;
}

@media (prefers-reduced-motion: reduce) {
  .feuille-deploiement {
    animation: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Espace/MaFeuilleDeTemps.css"],"names":[],"mappings":"AAAA;;;;;EAKE;AACF;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,eAAe,EAAE;AACpC;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE;IACE,eAAe;EACjB;AACF","sourcesContent":["/*\n * « Ma feuille de temps » : un panneau qui s'ouvre (éditeur d'un jour,\n * confirmation d'envoi) se déplie en 180 ms. Seuls l'opacité et la position\n * bougent : rien ne force la mise en page à se recalculer. Pas de mouvement\n * pour qui a demandé d'en réduire.\n */\n@keyframes feuille-deploiement {\n  from { opacity: 0; transform: translateY(-6px); }\n  to { opacity: 1; transform: none; }\n}\n\n.feuille-deploiement {\n  animation: feuille-deploiement 180ms ease-out;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .feuille-deploiement {\n    animation: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
